import { translatorData } from './translatorData';

export default function translator(sentence) {
	let traduction = sentence;
	if (sentence in translatorData) {
		traduction = translatorData[sentence].SPANISH;
	}
	return traduction;
}
